export class UserEnvironment {
  public static getName = () => 'benzinga-user';
  public static getEnvironment = (env: Record<string, string>) => ({
    lavapressUrl: new URL(env.lavapressUrl ?? 'https://www.benzinga.com/lavapress/api/'),
    segmentUrl: new URL(env.segmentUrl ?? 'https://www.benzinga.com/'),
    url: new URL(env.url ?? 'https://accounts.benzinga.com/'),
  });
}
